"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Observer = void 0;

var Observer =
/** @class */
function () {
  function Observer() {
    this.listeners = {};
  }

  Observer.prototype.on = function (eventName, callback) {
    var _a;

    this.listeners = __assign(__assign({}, this.listeners), (_a = {}, _a[eventName] = Boolean(this.listeners[eventName]) ? __spreadArray(__spreadArray([], this.listeners[eventName]), [callback]) : [callback], _a));
    return this;
  };

  Observer.prototype.off = function (eventName, callback) {
    var _a;

    if ((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length) {
      this.listeners[eventName] = this.listeners[eventName].filter(function (listener) {
        return listener !== callback;
      });
    }

    return this;
  };

  Observer.prototype.emit = function (eventName) {
    var _a;

    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    if ((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length) {
      this.listeners[eventName].forEach(function (listener) {
        listener.apply(void 0, args);
      });
    }

    return this;
  };

  return Observer;
}();

exports.Observer = Observer;